import styled from 'styled-components';
import {colors, devices} from '../../utils/styled/_variables.styled';
import {InfiosArrowWrapper} from '../FormComponents/Dropdown/Dropdown.style';

export const InfiosLanguageOption = styled.option`
    background-color: ${colors.white};
    color: ${colors.infiosGray};
`;

export const InfiosLanguageSelector = styled.select`
    max-width: 34px;
    padding: 0 14px 0 0;
    background-color: transparent;
    color: ${colors.white};
    border: none;
    outline: none;
    appearance: none;

    &:focus-within {
        & ~ ${InfiosArrowWrapper} {
            svg {
                transform: rotate(180deg);
            }
        }
    }
`;

export const InfiosLanguageSelectorWrapper = styled.section`
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: ${props => ((props.blackLetter === "whiteBlack" || props.blackLetter === "transparentBlack") ? colors.infiosGray : colors.white)};
    margin-left: 24px;
    cursor: pointer;

    &:active {
        ${InfiosLanguageSelector} {
            color: ${colors.bluePressed};

            & ~ ${InfiosArrowWrapper} {
                svg {
                    path {
                        fill: ${colors.bluePressed};
                    }
                }
            }
        }
    }

    .basic-single {
        z-index: 2;
    }

    ${InfiosArrowWrapper} {
        position: absolute;
        width: 8px;
        top: 50%;
        left: auto;
        right: 0;
        bottom: auto;
        transform: translateY(-50%);
        pointer-events: none;

        svg {
            path {
               fill: ${colors.white};
            }
        }
    }

    @media ${devices.mobileAndTablet} {
        display: none;
    }

    .select__indicators{
        svg {
            height: 15px;
        }
    }

    @keyframes fadeIn {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;;
        }
    }

    @keyframes fadeOut {
        0% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }

    .menu--close {
        animation: fadeOut 0.4s ease-in-out;
    }

    &.in__footer {
        .select__control:hover {
            .select__single-value, svg path {
                color: ${colors.white};
                fill: ${colors.white};
                opacity: 0.64;
            }
        }
    }
`;

export const customSelectMenuStyles = {
    control: (baseStyles, state) => ({
        width: 55,
        height:25,
        display: 'flex',
        marginBottom: 0,
      }),
      singleValue: (baseStyles, state) => ({
        width: 30,
        textTransform:'uppercase',
        gridArea: '1 / 1 / 2 / 3',
        overflow: 'hidden',
        marginLeft: 2,
        marginRight: 2,
        boxSizing: 'border-box',
        fontSize: 14,
      }),
      container: (baseStyles, state) => ({
        ...baseStyles,
        fontFamily: 'Infios',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: 14,
        lineHeight: '100%',
      }),
      dropdownIndicator: (baseStyles, state) => ({
        paddingTop:state.selectProps.menuIsOpen ? 3 : 4,
        transform: state.selectProps.menuIsOpen  ? 'rotate(180deg)' : 'unset',
        marginRight: 5,
      }),
    menu:(baseStyles, state) => ({
        ...baseStyles,
        position: 'fixed',
        top:30,
        width:'fit-content',
        height:'fit-content',
        borderRadius: 0,
        animation: 'fadeIn 0.4s ease-in-out',
    }),
    option: (baseStyles, state) => ({
        ...baseStyles,
        background: "transparent",
        color: 'black',
        '&:hover': {
            color: colors.blueHover,
         },
    }),
    indicatorSeparator: (baseStyles, state) => ({
        display:'none',
    }),
}
